export default __webpack_public_path__ + "static/media/12.ed3cdb53.jpg";